import { UPDATE_FOOTER } from "../actions/type";

const initialState = {
    brands: [],
    complains: [],
    social: {
        content: "<ul class=\"socials-list\"><li><a href=\"https://www.facebook.com/\" target=\"_blank\" rel=\"noreferrer\"><img src=\"uploads/images/social_fb.png\" alt=\"Facebook\"/></a></li><li><a href=\"https://www.aparat.com/\" target=\"_blank\" rel=\"noreferrer\"><img src=\"uploads/images/social_aparat.png\" alt=\"Aparat\"/></a></li><li><a href=\"https://t.me/\" target=\"_blank\" rel=\"noreferrer\"><img src=\"uploads/images/social_telegram.png\" alt=\"Telegram\"/></a></li><li><a href=\"https://www.instagram.com/\" target=\"_blank\" rel=\"noreferrer\"><img src=\"uploads/images/social_instagram.png\" alt=\"Instagram\"/></a></li></ul>",
    },
    lastUpdate: "2020-01-01",
};

export default function footer(state = initialState, action = {}) {
    switch (action.type) {
        case UPDATE_FOOTER:
            const { data, lastUpdate } = action;

            return {
                brands: data.brands,
                complains: data.complains,
                social: data.social,
                lastUpdate,
            };
        default:
            return state;
    }
};
